import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useFormContext } from "react-hook-form";
import { useTranslationApp } from "../../../lib/i18next";
import {
  GOOGLE_SEARCH_TERMS_DESCRIPTION,
  GOOGLE_SEARCH_TERMS_TITLE,
} from "../../../i18n/keysTranslations";
import { SEARCH_TERM_KEYWORD_TYPE_NEGATIVE } from "../../../utils/options";
import SearchTermsGoogleTable from "./SearchTermsGoogleTable";
import SearchTermKeywordModal from "./SearchTermKeywordModal";
import useGoogleAdGroupSearchTerms from "./useGoogleAdGroupSearchTerms";

const SearchTermsGoogleContainer = ({
  enabled,
  idPlatform,
  integrationID,
  adAccountID,
  disabled = false,
  keywordsName,
  keywordsNegativeName,
  canAddPositiveKeywords = true,
}) => {
  const { t } = useTranslationApp();
  const { getValues, setValue, watch } = useFormContext();
  const [searchTermToAdd, setSearchTermToAdd] = useState(null);
  const { searchTerms, loading } = useGoogleAdGroupSearchTerms({
    enabled,
    idPlatform,
    integrationID,
    adAccountID,
  });
  const keywords = watch(keywordsName) || [];
  const keywordsNegative = watch(keywordsNegativeName) || [];

  const onAddKeyword = ({ keyword, type }) => {
    const fieldName =
      type === SEARCH_TERM_KEYWORD_TYPE_NEGATIVE
        ? keywordsNegativeName
        : keywordsName;
    const currentKeywords = getValues(fieldName) || [];
    setValue(fieldName, [keyword, ...currentKeywords], {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  if (!enabled) {
    return null;
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          mt: 1,
          mb: 1.5,
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, fontSize: "18px" }}
        >
          {t(GOOGLE_SEARCH_TERMS_TITLE)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t(GOOGLE_SEARCH_TERMS_DESCRIPTION)}
        </Typography>
      </Box>
      <SearchTermsGoogleTable
        searchTerms={searchTerms}
        loading={loading}
        onAddSearchTerm={disabled ? undefined : setSearchTermToAdd}
      />
      {searchTermToAdd && (
        <SearchTermKeywordModal
          modalOpen={true}
          searchTerm={searchTermToAdd}
          currentKeywords={keywords}
          currentKeywordsNegative={keywordsNegative}
          canAddPositiveKeywords={canAddPositiveKeywords}
          onCloseModal={() => setSearchTermToAdd(null)}
          onSubmit={onAddKeyword}
        />
      )}
    </Box>
  );
};

export default SearchTermsGoogleContainer;
